import { useEffect, useState } from "react";
import { ArrowUp, MessageCircle } from "lucide-react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { companyInfo } from "@/data/siteData";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export function SiteLayout() {
  const location = useLocation();
  const reduceMotion = useReducedMotion();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="site-shell">
      <ScrollToTop />
      <Header />
      <AnimatePresence mode="wait" initial={false}>
        <motion.main
          id="main-content"
          key={location.pathname}
          initial={reduceMotion ? false : { opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          exit={reduceMotion ? undefined : { opacity: 0 }}
          transition={{ duration: 0.22 }}
        >
          <Outlet />
        </motion.main>
      </AnimatePresence>
      <Footer />

      <a
        className="messenger-fab"
        href={companyInfo.messengerUrl}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat with ACES Travel on Messenger"
      >
        <MessageCircle />
        <span>Chat with us</span>
      </a>

      <AnimatePresence>
        {showTop && (
          <motion.button
            className="scroll-top"
            aria-label="Scroll to top"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            onClick={() => window.scrollTo({ top: 0, behavior: reduceMotion ? "instant" : "smooth" })}
          >
            <ArrowUp />
          </motion.button>
        )}
      </AnimatePresence>

    </div>
  );
}
